import React from 'react'
import { Link } from "react-router-dom";


const HomeAbout = () => {
    return (
        <>

            <div className="about-area py-120" style={{ marginTop: "-100px" }}>
                <div className="container">
                    <div className="row g-4 align-items-center">

                        <div className="col-lg-6">
                            <div className="about-right wow fadeInRight" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInRight' }}>
                                <div className="site-heading mb-3">
                                    <span className="site-title-tagline"><i className="far fa-book-open-reader" /> About Us</span>
                                    <h2 className="site-title">
                                        Welcome to Priyadarshani Convent High School
                                    </h2>
                                </div>
                                <p className="about-text" style={{ textAlign: "justify" }}>
                                    Established in 2012, Priyadarshani Convent High School, Satna is dedicated to "Empowering Minds, Shaping Futures." Situated in Swami Chowk, Mukhtiyarganj Satna (M.P.), our English medium institution provides quality education from Nursery to Class 10th. We take pride in our, academic excellence, affordable fee structure, and a nurturing environment that fosters discipline, innovation, and holistic development.
                                </p>
                                <div className="about-content">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="about-item">
                                                <div className="about-item-icon">
                                                    <img src="assets/img/icon/open-book.svg" alt />
                                                </div>
                                                <div className="about-item-content">
                                                    <h5>Fully CCTV Campus</h5>
                                                    <p>We use CCTV security in classroom to see activity of student with school security camera footage, the administrators can keep track of student’s activity.</p>
                                                </div>
                                            </div>
                                            <div className="about-item">
                                                <div className="about-item-icon">
                                                    <img src="assets/img/icon/global-education.svg" alt />
                                                </div>
                                                <div className="about-item-content">
                                                    <h5>20-25 Student in each Classroom</h5>
                                                    <p>Having fewer students means that each one can get the attention they need from their teacher.</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="about-bottom">
                                    <Link to="/contact-us" className="theme-btn">Discover More<i className="fas fa-arrow-right-long" /></Link>
                                    <div className="about-phone">
                                        <div className="icon"><i className="fal fa-headset" /></div>
                                        <div className="number">
                                            <span>Call Now</span>
                                            <h6><a href="tel:+91 7987105491">+91 7987105491</a></h6>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-lg-6">
                            <div className="about-left wow fadeInLeft" data-wow-delay=".25s" style={{ visibility: 'visible', animationDelay: '0.25s', animationName: 'fadeInLeft' }}>
                                <div className="about-img">
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <img className="img-1" src="assets/school/001.png" alt />
                                            <div className="about-experience mt-4">
                                                <div className="about-experience-icon">
                                                    <img src="assets/img/icon/exchange-idea.svg" alt />
                                                </div>
                                                <b className="text-start" style={{ fontSize: "27px" }}>12+ Years</b>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <img className="img-2" src="assets/school/003.png" alt />
                                            <img className="img-3 mt-4" src="assets/school/002.png" alt />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="counter-area pt-60 pb-60">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box">
                                <div className="icon">
                                    <img src="assets/img/icon/course.svg" alt />
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to={500} data-speed={3000}>35+</span>
                                    <h6 className="title"> Teachers </h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box">
                                <div className="icon">
                                    <img src="assets/img/icon/graduation.svg" alt />
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to={1900} data-speed={3000}>15+</span>
                                    <h6 className="title">Classroom</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box">
                                <div className="icon">
                                    <img src="assets/img/icon/teacher-2.svg" alt />
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to={750} data-speed={3000}>500+</span>
                                    <h6 className="title">Students</h6>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-3 col-sm-6">
                            <div className="counter-box">
                                <div className="icon">
                                    <img src="assets/img/icon/award.svg" alt />
                                </div>
                                <div>
                                    <span className="counter" data-count="+" data-to={30} data-speed={3000}>20+</span>
                                    <h6 className="title">Win Awards</h6>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>





        </>
    )
}

export default HomeAbout